<script setup>
import { computed } from 'vue'
import { noImage } from '@/common/helper'
import { useCatalogState } from '../composables/CatalogState'
import ArticleGrid from './ArticleGrid.vue'
import ArticleList from './ArticleList.vue'

const {
  displayMode,
  rowsFiltered,
} = useCatalogState();

const hasArticles = computed(() => rowsFiltered.value?.length > 0);
const articlesCount = computed(() => rowsFiltered.value?.length);
</script>

<template>
  <div class="mb-8" >
    <div class="mt-8 dark:text-gray-400">
      <span class="text-lg font-medium">Artikli</span>
      <span class="pl-2 relative" style="bottom: 1px" v-if="hasArticles">({{ articlesCount }})</span>
    </div>

    <ArticleGrid v-if="displayMode == 'grid' && hasArticles" />

    <ArticleList v-else-if="displayMode == 'list' && hasArticles" />

    <!-- No article found -->
    <div class="relative sm:grid sm:grid-cols-1 gap-4 w-full mt-2 mb-32" v-else>
      <span class="text-slate-500">(brez artiklov)</span>
    </div>

  </div>
</template>